export default {
    data() {
        return {
            searchContent: "",
            tableData: [],
            total: 0,
            pageIndex: 1,
            pageSize: 12,
            dialogManageShow: false,
            manageForm: {},
            multipleSelection: [],
        }
    },
    mounted: function() {
        this.query();
    },
    methods: {
        clickEvent: function(id) {
            switch (id) {
                case "search": //搜索
                    this.pageIndex = 1;
                    this.query();
                    break;
                case "add": //添加
                    this.manageForm = {};
                    this.dialogManageShow = true;
                    break;
                case "edit": //编辑
                    if (this.multipleSelection.length != 1) {
                        this.$message.closeAll();
                        this.$message.warning("请选择一项进行修改");
                        return;
                    }
                    this.manageForm = Object.assign({}, this.multipleSelection[0]);
                    this.dialogManageShow = true;
                    break;
                case "manageConfirm": //确定
                    this.$refs['manageForm'].validate((valid) => {
                        if (valid) {
                            if (this.manageForm.id == null)
                                this.add();
                            else
                                this.edit();
                        } else {
                            return false;
                        }
                    });
                    break;
                case "delete": //删除
                    if (this.multipleSelection.length == 0) {
                        this.$message.closeAll();
                        this.$message.warning("请至少选择一项进行删除");
                        return;
                    }
                    this.$confirm('此操作将删除所选中的承包商类型, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.delete();
                    }).catch(() => {});
                    break;
                default:
                    break;
            }
        },

        /**
         * table选中事件
         * @param {*} val 
         */
        tableColumnCheckEvent: function(val) {
            this.multipleSelection = val;
        },

        /**
         * 新增
         */
        add: function() {
            this.$post({
                url: "/contractorType/add",
                params: {
                    name: this.manageForm.name,
                    description: this.manageForm.description
                }
            }).then(res => {
                this.manageForm = {};
                this.dialogManageShow = false;
                this.$message.closeAll();
                this.$message.success("添加成功");
                this.query();
            });
        },

        /**
         * 批量删除
         */
        delete: function() {
            var ids = new Array();
            this.multipleSelection.forEach(elem => {
                ids.push(elem.id);
            });
            this.$post({
                url: "/contractorType/delete",
                params: {
                    ids: ids
                }
            }).then(res => {
                this.$message.closeAll();
                this.$message.success("删除成功");
                this.query();
            });
        },

        /**
         * 修改
         */
        edit: function() {
            this.$post({
                url: "/contractorType/edit",
                params: {
                    id: this.manageForm.id,
                    name: this.manageForm.name,
                    description: this.manageForm.description
                }
            }).then(res => {
                this.manageForm = {};
                this.dialogManageShow = false;
                this.$message.closeAll();
                this.$message.success("修改成功");
                this.query();
            });
        },

        /**
         * 查询
         */
        query: function() {
            this.$post({
                url: 'contractorType/queryByPage',
                params: {
                    keyWord: this.searchContent,
                    pageIndex: this.pageIndex,
                    pageSize: this.pageSize
                }
            }, true).then(response => {
                this.total = response.total;
                this.tableData = response.data;
            });
        },

        /**
         * 翻页
         * @param {*} val 
         */
        handlePageChange: function(val) {
            this.pageIndex = val;
            this.query();
        }
    }
}